<template>
  <div>
    <template v-if="permitReport">
      <a href="#" class="add-hunter-link" @click.prevent="resetForm(true)">{{ $t('Нет в базе данных. Добавить охотника') }}</a>
    </template>
    <template v-else>
      <div class="add-npa-row">
        <v-btn class="v-btn btn-add-category" @click="resetForm(true)">
          {{ $t('Добавить') }}
        </v-btn>
      </div>
    </template>
    <v-dialog v-model="createDialog" max-width="640">
      <v-card class="modal hunter-modal">
        <div class="modal-head">
          <template>
            {{ $t('Создание') }}
          </template>
          <v-btn color="modal-close" @click="resetForm()">
            <img src="@/assets/img/close-icon.png" alt="icon">
          </v-btn>
        </div>
        <div class="modal-body">
          <v-form
            ref="form"
            lazy-validation
            @submit.prevent="checkUniqueHunter"
          >
            <v-row :class="{ invalid: $v.hunter.lastName.$error }">
              <v-col cols="4" md="4" class="input-label">
                <v-label>{{ $t('Фамилия') }}: <span class="asterix">*</span></v-label>
                <fieldInfo :info="$t('Фамилия')"/>
              </v-col>
              <v-col class="input-field">
                <v-text-field
                  v-model="hunter.lastName"
                  outlined
                  dense
                  class="size-small"
                />
              </v-col>
            </v-row>
            <v-row :class="{ invalid: $v.hunter.firstName.$error }">
              <v-col cols="4" md="4" class="input-label">
                <v-label>{{ $t('Имя') }}: <span class="asterix">*</span></v-label>
                <fieldInfo :info="$t('Имя')"/>
              </v-col>
              <v-col class="input-field">
                <v-text-field
                  v-model="hunter.firstName"
                  outlined
                  dense
                  class="size-small"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="4" class="input-label">
                <v-label>{{ $t('Отчество') }}:</v-label>
                <fieldInfo :info="$t('Отчество')"/>
              </v-col>
              <v-col class="input-field">
                <v-text-field
                  v-model="hunter.secondName"
                  outlined
                  dense
                  class="size-small"
                />
              </v-col>
            </v-row>
            <v-row :class="{ invalid: $v.hunter.country.$error }">
              <v-col cols="4" md="4" class="input-label">
                <v-label>{{ $t('Гражданство') }}: <span class="asterix">*</span></v-label>
                <fieldInfo :info="$t('Гражданство')"/>
              </v-col>
              <v-col class="input-field">
                <div class="select-def">
                  <v-autocomplete
                    :items="refCountry"
                    item-value="id"
                    item-text="transName"
                    v-model="hunter.country"
                    outlined
                    dense
                    clearable
                  />
                </div>
              </v-col>
            </v-row>
            <v-row v-if="hunter.country === KyrgyzstanCountry" :class="{ invalid: $v.hunter.pin.$error }">
              <v-col cols="4" md="4" class="input-label">
                <v-label>{{ $t('ПИН') }}: <span class="asterix">*</span></v-label>
                <fieldInfo :info="$t('ПИН')"/>
              </v-col>
              <v-col class="input-field">
                <v-text-field
                  v-model="hunter.pin"
                  outlined
                  dense
                  class="size-small"
                />
              </v-col>
            </v-row>
            <!--Кнопки действии-->
            <div class="form-action text-center">
              <button
                class="btn btn-default blue"
                type="submit"
              >
                {{ $t('Сохранить') }}
              </button>
              <button
                class="btn btn-default gray"
                type="button"
                @click="resetForm()"
              >
                {{ $t('Отмена') }}
              </button>
            </div>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import fieldInfo from '@/components/app/fieldInfo'
import { required, requiredIf, maxLength, minLength } from 'vuelidate/lib/validators'
import Hunters from '@/model/hunters'

export default {
  props: {
    refCountry: Array,
    KyrgyzstanCountry: String | Number,
    permitReport: Boolean
  },
  components: {
    fieldInfo
  },
  data: () => ({
    createDialog: false,
    hunter: {},
    rules: {
      hunter: {
        lastName: { required },
        firstName: { required },
        country: { required },
        pin: {
          required: requiredIf(
            function () {
              return this.hunter.country === this.KyrgyzstanCountry
            }),
          minLength: minLength(14),
          maxLength: maxLength(14)
        }
      }
    }
  }),
  validations () {
    return this.rules
  },
  methods: {
    resetForm (flag = false) {
      this.hunter = {}
      this.createDialog = flag
    },
    createHunter () {
      if (!this.validateForm()) {
        return
      }
      if (this.hunter.country !== this.KyrgyzstanCountry) {
        this.hunter.pin = null
      }
      Hunters.create(this.hunter).then((response) => {
        if (response.status === 201) {
          this.$noty.success(this.$i18n.t('Успешно добавлено'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
          if (this.permitReport === true) {
            this.$emit('hunter-new', {
              id: response.data.id,
              fio: response.data.ooptHunterFio
            })
          } else {
            this.$router.push({
              name: 'hunter-edit',
              params: {
                id: response.data.id
              }
            })
          }
        }
      })
        .catch((error) => {
          let msg = error.message
          if (error.response) {
            if (error.response.data.form) {
              msg = this.$i18n.t(error.response.data.form.message)
            } else if (error.response.data.message) {
              msg = this.$i18n.t(error.response.data.message)
            }
          }
          this.$noty.error(msg, {
            killer: true,
            timeout: 1500,
            layout: 'topRight'
          })
        })
    },
    checkUniqueHunter () {
      if (!this.validateForm()) {
        return
      }
      Hunters.checkUniqueHunter(this.hunter).then((response) => {
        if (response.status === 200) {
          if (response.data.msg !== '') {
            if (confirm(response.data.msg)) {
              this.createHunter()
            }
          } else {
            this.createHunter()
          }
        }
      })
        .catch((error) => {
          if (error.response.status === 400) {
            this.$noty.error(error.response.data.msg, {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
          } else {
            console.log(error)
          }
        })
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    }
  }
}
</script>

<style scoped>
</style>
